const k12opt = JSON.parse(sessionStorage.getItem('k12opt'));
const AXINFU_ERROR = {
	CUS_JMLX_BT: '减免类型不能为空',
	XTGL_ZDXMC_BT: '字典项名称不能为空',
	CUS_BJ_NJ_BT: '年级不能为空',
	JK_KSSJ_GS: '开始时间格式错误',
	CUS_BJ_ZY_BT: `${ (k12opt && k12opt.zy) || '专业'}不能为空`,
	COMMON_SBH_CD: '最大长度为64位',
	CUS_YHMC_CD: '银行名称最大长度为64位',
	CUS_BJ_XQ_BT: '校区不能为空',
	CUS_BJ_BYRQ_GS: '毕业日期格式错误',
	COMMON_CJXX_CD: '采集信息最大长度为64位',
	CUS_XMMC_BT: '项目名称不能为空',
	DJKS_XSXX_NULL: '未找到学生信息',
	CUS_BJ_PLXH_GS: '请输入整数',
	XTGL_ZDMC_CD: '字典名称最大长度为64位',
	CUS_SZBJ_CD: `所在${(k12opt && k12opt.bj) || '班级'}不能为空`,
	COMMON_YXJG_BT: `${ (k12opt && k12opt.yx) || '院系'}结构不能为空`,
	COMMON_RS_BT: '人数不能为空',
	CUS_YKTH_CD: '一卡通号最大长度为64位',
	DJKS_XMMC_CD: '项目名称最大长度为64位',
	XTGL_ZYMC_CD: `${ (k12opt && k12opt.zy) || '专业'}最大长度为64位`,
	COMMON_YHZH_BT: '银行账户不能为空',
	XTGL_XQMC_CD: '校区名称最大长度为64位',
	DJKS_JZSJ_GS: '截止时间格式错误',
	CUS_YHKH_CD: '银行卡号最大长度为64位',
	YSK_JZSJ_BT: '截止时间不能为空',
	XTGL_BMMC_CD: '部门名称最大长度为64位',
	YSK_ZX_JE_GS: '请输入金额，保留2位小数',
	YSK_ZDYBH_CD: '自定义编号最大长度为64位',
	COMMON_MB_SFX_BT: '收费项名称不能为空',
	COMMON_SFX_BT: '收费项不能为空',
	COMMON_JZSJ_GS: '截止时间格式错误',
	XTGL_ZDXDM_BT: '字典项代码不能为空',
	CUS_XM_CD: '姓名最大长度为64位',
	COMMON_KSSJ_GS: '开始时间格式错误',
	COMMON_JE_FW: '最高金额不能小于最低金额',
	COMMON_MESX_BT: '名额上限不能为空',
	COMMON_BMSL_BT: '单人报名数量上限不能为空',
	COMMON_BMSL_FW: '单人报名数量上限不能超过名额上限',
	JK_JZSJ_BT: '截止时间不能为空',
	COMMON_JE_GS: '金额格式错误',
	XTGL_CSMC_BT: '参数名称不能为空',
	DJKS_SFSM_CD: '收费说明最大长度为64位',
	DJKS_XMMC_BT: '项目名称不能为空',
	JK_XMMC_BT: '项目名称不能为空',
	MB_MBMC_CD: '模板名称最大长度为64位',
	COMMON_RZMC_BT: '名称不能为空',
	XTGL_ZDXDM_CD: '字典项代码最大长度为64位',
	COMMON_XM_CD: '姓名最大长度为64位',
	JK_JZSJ_GS: '截止时间格式错误',
	COMMON_JZSJ_BT: '截止时间不能为空',
	COMMON_SBH_BT: '识别号不能为空',
	DJKS_ZDYBH_CD: '自定义编号最大长度为64位',
	DJKS_JZSJ_BT: '截止时间不能为空',
	COMMON_XMMC_BT: '项目名称不能为空',
	JK_KSSJ_BT: '开始时间不能为空',
	XTGL_LXFS_CD: '联系方式最大长度为64位',
	XTGL_ZYDM_CD: '资源代码最大长度为64位',
	YSK_KSSJ_GS: '开始时间格式错误',
	XTGL_BMMC_BT: '部门名称不能为空',
	COMMON_CJXX_BT: '采集信息不能为空',
	CUS_BJ_BJDM_CD: `${(k12opt && k12opt.bj) || '班级'}代码最大长度为64位`,
	XTGL_MBMC_BT: '模板名称不能为空',
	XTGL_ZYMC_BT: `${ (k12opt && k12opt.zy) || '专业'}名称不能为空`,
	XTGL_ZDMC_BT: '字典名称不能为空',
	COMMON_PXH_GS: '排列序号格式错误,只能输入数字',
	XTGL_DLMM_CD: '登录密码最大长度为64位',
	YSK_SFBZ_BT: '请选择收费标准',
	XTGL_YMYS_BT: '页面元素不能为空',
	COMMON_ZDYBH_CD: '自定义编号最大长度为64位',
	XTGL_SFLX_BT: '适用收费类型不能为空',
	XTGL_MBMC_CD: '模板名称最大长度为64位',
	CUS_JZRQ_BT: '截止日期不能为空',
	DJKS_KSSJ_GS: '开始时间格式错误',
	COMMON_SFSM_CD: '收费说明最大长度为64位',
	YSK_ZX_CDSX_GS: '请输入整数',
	YSK_ZX_SFXMC_BT: '收费项名称不能为空',
	YSK_BZ_MC_BT: '收费项名称不能为空',
	YSK_SFKM_DM_BT: '收费科目不能为空',
	COMMON_SFX_CD: '收费项最大长度为64位',
	COMMON_CJXX_LX: '采集信息类型不能为空',
	COMMON_MB_SFX_CD: '收费项名称最大长度为64位',
	XTGL_SJBM_BT: '上级部门不能为空',
	COMMON_JE_BT: '请输入金额，保留2位小数',
	CUS_KSH_CD: '考试号最大长度为64位',
	COMMON_FBLX_BT: '发布类型不能为空',
	CUS_BJ_PLXH_CD: '排列序号最大长度为64位',
	CUS_XM_BT: '姓名不能为空',
	COMMON_RZSFLX_BT: '适用收费类型不能为空',
	XTGL_DYDM_BT: '资源代码不能为空',
	COMMON_SJH_GS: '手机号格式错误',
	COMMON_RZMC_CD: '名称最大长度为64位',
	XTGL_JSMC_CD: '角色名称最大长度为64位',
	XTGL_SJCD_BT: '上级菜单不能为空',
	COMMON_JE_CD: '金额最大长度为64位',
	YSK_ZX_CDSX_BT: '贷款冲抵顺序不能为空',
	YSK_SK_CDSX_BT: '收款冲抵顺序不能为空',
	JK_XMMC_CD: '项目名称最大长度为64位',
	YSK_KSSJ_BT: '开始时间不能为空',
	XTGL_YMYS_CD: '页面元素最大长度为64位',
	DJKS_XSXX_EXISTS: '学号不能重复添加',
	COMMON_ZFQD_BT: '支付渠道不能为空',
	YSK_ZX_SFXLX_BT: '收费项类型不能为空',
	CUS_BJ_YX_BT: `${ (k12opt && k12opt.yx) || '院系'}不能为空`,
	MB_MBSM_CD: '模板说明最大长度为64位',
	COMMON_SBH_LX_BT: '识别号类型不能为空',
	MB_SYSFLX_BT: '适用收费类型不能为空',
	COMMON_XMMC_CD: '项目名称最大长度为64位',
	CUS_XH_CD: '学号最大长度为64位',
	CUS_SJH_CD: '手机号最大长度为64位',
	YSK_XSXX_BT: '学号不能为空',
	XTGL_ZYLX_BT: `${ (k12opt && k12opt.zy) || '专业'}类型不能为空`,
	XTGL_SJYX_BT: `上级${ (k12opt && k12opt.yx) || '院系'}不能为空`,
	DJKS_SJH_EXISTS: '手机号不能重复添加',
	JK_ZDYBH_CD: '自定义编号最大长度为64位',
	YSK_XMMC_BT: '项目名称不能为空',
	CUS_XSZT_BT: '学生状态不能为空',
	XTGL_XM_CD: '姓名最大长度为64位',
	COMMON_ZT_BT: '状态不能为空',
	YSK_ZX_JE_BT: '金额不能为空',
	COMMON_SHH_BT: '商户号不能为空',
	XTGL_JSMC_BT: '角色名称不能为空',
	DJKS_KSSJ_BT: '开始时间不能为空',
	XTGL_XM_BT: '姓名不能为空',
	JK_SFSM_CD: '收费说明最大长度为64位',
	DJKS_XSXX_BT: '学号不能为空',
	YSK_ZX_SFXMC_CD: '收费项名称最大长度为64位',
	XTGL_XQMC_BT: '校区名称不能为空',
	XTGL_CSMC_CD: '参数名称最大长度为64位',
	COMMON_FPMB_MC: '模板名称不能为空',
	XTGL_BMBM_BT: '部门编码不能为空',
	XTGL_CSZ_CD: '参数值最大长度为64位',
	COMMON_RZZH_BT: '入账账户不能为空',
	YSK_XSXX_EXISTS: '学号不能重复添加',
	XTGL_DLMM_BT: '登录密码不能为空',
	YSK_ZX_BZSM_CD: '标准说明最大长度为64位',
	MB_MBNR_CD: '模板内容不能为空',
	XTGL_CDMC_CD: '菜单名称最大长度为64位',
	COMMON_SJH_BT: '手机号不能为空',
	CUS_DKLX_BT: '贷款类型不能为空',
	CUS_SFZH_CD: '身份证号最大长度为64位',
	YSK_XMMC_CD: '项目名称最大长度为64位',
	XTGL_CDMC_BT: '菜单名称不能为空',
	CUS_XH_BT: '学号不能为空',
	COMMON_FPMB_NUM: '必须为正整数且不能为空',
	YSK_SFSM_CD: '收费说明最大长度为500',
	XTGL_ZDXMC_CD: '字典项名称最大长度为64位',
	XTGL_LXFS_BT: '联系方式不能为空',
	CUS_BJ_BJMC_CD: `${(k12opt && k12opt.bj) || '班级'}名称最大长度为64位`,
	YSK_ZX_JE_CD: '金额最大长度为10位整数和两位小数',
	YSK_JZSJ_GS: '截止时间格式错误',
	COMMON_XM_BT: '姓名不能为空',
	YSK_ZX_CDSX_CD: '冲抵顺序最大长度为64位',
	MB_MBMC_BT: '模板名称不能为空',
	COMMON_KSSJ_BT: '开始时间不能为空',
	XTGL_CSZ_BT: '参数值不能为空',
	YSK_SFND_BT: '收费年度不能为空',
	XTGL_YXMC_BT: `${ (k12opt && k12opt.yx) || '院系'}名称不能为空`,
	XTGL_SSBM_BT: '所属部门不能为空',
	XTGL_YXMC_CD: `${ (k12opt && k12opt.yx) || '院系'}名称最大长度为64位`,
	MB_MBLX_GS: '二级模板不适用于党费及捐款',
	CUS_BJ_BJMC_BT: `${(k12opt && k12opt.bj) || '班级'}不能为空`,
	YSK_XSXX_NULL: '未找到学生信息',
	YSK_XMFB_CF: '该年度应收款已发布',
	YSK_DRTD_ZY: '该导入通道正在被 ${czy} 占用',
	YSK_QD_CF: '学生[${xh}]的[${zx_mc}]已发布',
	BIZ_SUCCESS: '操作成功',
	BIZ_ERROR: '操作失败',
	BIZ_UNKNOWN: '未知错误',
	DZFP_SL_BT: '税率不能为空',
	DZFP_MC_BT: '名称不能为空',
	DZFP_SFXMC_BT: '收费项名称不能为空',
	DZFP_PJCS_BT: '票据厂商不能为空',
	DZFP_PJLX_BT: '票据类型不能为空',
	DZFP_KPBH_MC_BT: '开票编号名称不能为空',
	DZFP_KPBH_BT: '开票编号不能为空',
	PJMB_PJMC_BT: '票据名称不能为空',
	PJMB_DYSL_GS: '单页打印数量必须为正整数且不能为空',
	PJMB_PJLX_BT: '票据类型不能为空',
	PJMB_SYLX_BT: '适用类型不能为空',
	TKFS_BT: '退款方式不能为空',
	TKRQ_BT: '退款日期不能为空',
	NULL_RECEIVABLE_SUBJECT: '收费科目不能为空',
	YSK_CS_DM_BT: '开票厂商不能为空',
	NUll_YJKM: '一级科目不能为空',
	NUll_SFKM: '收费科目不能为空',
	NULL_ACCOUNT_NAME: '科目名称不能为空',
	NULL_ACCOUNT_BS: '科目标识不能为空',
	NULL_RZZH: '入账账户不能为空',
	NULL_TZYY: '调整原因不能为空',
	NULL_PROVIDER: '线上支付渠道不能为空',
	NULL_INFO_NAME: '信息名称不能为空',
	TAG_BT: '标签不能为空',
	// 学生信息动态控制表单必填字段时
	xb: '性别不能为空',
	jg: '籍贯不能为空',
	dz: '联系地址不能为空',
	zj_lx: '证件类型不能为空',
	mz: '民族不能为空',
	dzyx: '电子邮箱不能为空',
	zj_hm: '证件号码不能为空',
	zzmm: '政治面貌不能为空',
	csrq: '出生日期不能为空',
	gj: '国家地区不能为空',
	lxdh: '手机号不能为空',
	jflx: '缴费类型不能为空',
	xq_dm: '校区不能为空',
	pycc: '培养层次不能为空',
	jxbj_mc: '教学班级不能为空',
	ksh: '考生号不能为空',
	xs_lb: '学生类别不能为空',
	tzsh: '通知书号不能为空',
	xh_ls: '临时学号不能为空',
	xz: '学制不能为空',
	byyx: '毕业院校不能为空',
	rx_yf: '入学月份不能为空',
	by_rf: '毕业月份不能为空',
	jy_lb: '教育类别不能为空',
	zsbz: '住宿标准不能为空',
	bz: '备注不能为空',
	yh_zh: '银行账户不能为空',
	yh_zh_lx: '卡类型不能为空',
	yh_dm: '发卡行不能为空',
	yt_lx: '卡用途不能为空',
	khh_mc: '支行名称不能为空',
	TEM_CHARGE_KPTT_LX: '抬头类型不能为空',
	TEM_CHARGE_KPTT_MC: '抬头名称不能为空',
	TEM_CHARGE_NSR_SBH: '纳税人识别号不能为空'
};
module.exports = AXINFU_ERROR;
